import React from 'react';
import Weather from '../components/Weather';
import { useTheme } from '../lib/theme';

const WeatherPage = ({ onRecommendationShown }) => {
  const { theme } = useTheme();
  return <Weather theme={theme} onRecommendationShown={onRecommendationShown} />;
};

export default WeatherPage;
